var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTag = function SvgTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.27 2.355a2.5 2.5 0 0 1 1.085-1.084c.313-.16.638-.219.966-.246C3.63 1 4.007 1 4.443 1h3.802c.337 0 .634 0 .922.069.253.06.495.16.717.297.253.155.463.365.7.603l6.418 6.417c.47.471.86.86 1.15 1.202.302.356.547.716.686 1.145.216.664.216 1.38 0 2.045-.14.428-.384.788-.686 1.144-.29.342-.68.731-1.15 1.202l-1.878 1.878c-.471.471-.86.86-1.202 1.15-.356.302-.716.547-1.144.686a3.3 3.3 0 0 1-2.046 0c-.428-.14-.788-.384-1.144-.686-.342-.29-.731-.68-1.202-1.15L1.97 10.585c-.238-.238-.448-.448-.603-.7a2.5 2.5 0 0 1-.297-.718c-.07-.288-.07-.585-.07-.921L1 4.443c0-.436 0-.812.025-1.122.027-.327.086-.653.245-.966m5.521 2.782a1.655 1.655 0 1 0 0 3.309 1.655 1.655 0 0 0 0-3.31",
    clipRule: "evenodd"
  })));
};
export default SvgTag;